import { Injectable } from '@angular/core';
import { Http, Jsonp } from '@angular/http';
import 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { VersionService } from '../services/version.service';
import { Config } from '../classes/config';

@Injectable()
export class StudiesService {

  constructor(private _http: Http, private _jsonp: Jsonp, private ver: VersionService) { }

  get(id: number) {
    return this._http.get(`${Config.apiUrl}/onderzoek/Get?id=${id}&callback=JSONP_CALLBACK`)
      .map(resp => resp.json());
  }

  all() {
    return this._http.get(`${Config.apiUrl}/onderzoek/All?versionId=${this.ver.activeVersion()}&all=1&callback=JSONP_CALLBACK`)
      .map(resp => resp.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/studies.service.ts